<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';

function handleWindowResize() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}

onMounted(() => {
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowResize);
});
</script>

<template>
    <div id="app">
        <router-view />
    </div>
</template>
